import Vue from 'vue'
import App from './App.vue'
import VueRouter from 'vue-router'
import router from './route/routers'
import store from './store'
import { Tabbar,
        TabbarItem,
        RadioGroup,
        Radio,
        Picker,
        Popup,
        Area,
        Overlay,
        Swipe, 
        SwipeItem,
        List,
        Toast,
        Button ,
        Dialog 
    } from 'vant';
import VueAwesomeSwiper from 'vue-awesome-swiper'  //引入vue-awesome-swiper

import 'swiper/css/swiper.css'  //引入样式

Vue.use(VueAwesomeSwiper)  //使用插件
// Vue.use(directive )  //使用插件
// Vue.use(SwiperSlide)  //使用插件

Vue.use(List);


Vue.use(Swipe);
Vue.use(SwipeItem);
Vue.use(Overlay);
Vue.use(Area);
Vue.use(Popup);
Vue.use(Picker);
Vue.use(Radio);
Vue.use(RadioGroup)
Vue.use(Tabbar);
Vue.use(TabbarItem);
Vue.use(Toast);
Vue.use(Button);
Vue.use(Dialog);



import 'lib-flexible'
import '@/assets/css/reset.css'

Vue.use(VueRouter)

Vue.config.productionTip = false

Vue.prototype.inputBurl=function(){
    // window.scroll(0, 0);
}

window.addEventListener('resize', function() {
    // 变化后需要做的事
    store.commit('windowInnerHeight', {
            windowInnerHeight:window.innerHeight
        })
        
});


new Vue({
    store,
    router,
    render: h => h(App)
    
                                                                      
  }).$mount('#app')
